/**
 * Created by libaiqi on 2018/10/24.
 */

import Logic from '../logic-base'

const roleManageBiz = new Logic()

roleManageBiz.findAll = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.roleManage.findAll,
    data: data
  })
}

roleManageBiz.addRole = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.roleManage.addRole,
    data: data
  })
}

roleManageBiz.amendRole = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.roleManage.amendRole,
    data: data
  })
}

roleManageBiz.deleteRole = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.roleManage.deleteRole,
    data: data
  })
}

roleManageBiz.findRoleById = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.roleManage.findRoleById,
    data: data
  })
}

export default roleManageBiz
